import C from './constants'

export const setSo3CorrectionAction = (values) => (
    {
        type: C.SET_SO3_CORRECTION_VALUES,
        payload: values
    }
)
